module.exports = __webpack_public_path__ + "img/cooperative-logo.dca587d3.png";